// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","648":"component---src-templates-tenant-tsx"}[chunkId] || chunkId) + "-" + {"245":"19aef0535ea518093a1b","453":"6c1d6c003fbd9701ab2b","522":"2799c4e99985851125df","648":"272366b26aee91c41369"}[chunkId] + ".js";
};